import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { StoreProducts } from '../components';
import { CountrySelect } from '../components/ui';
import { StoreContext } from '../contexts/store.context';
import { UserContext, useCountryContext } from '../contexts';
import { StoreProviderValue } from '../models';
import { putUser } from '../services';
import { toast } from 'react-toastify';
import './SweepstakesPage.css';

export function SweepstakesPage() {
   const { raffles, setRaffles } = useContext<StoreProviderValue>(StoreContext);
   const { user, setUser } = useContext(UserContext);
   const { countries, isSweepstakeCountryAllowed } = useCountryContext();
   const [isUpdating, setIsUpdating] = useState(false);

   const hasValidCountry = user?.country && countries.find((c) => c.value === user.country);
   const isCountryAllowed = isSweepstakeCountryAllowed(user?.country);
   const showWarning = user?.country && !isCountryAllowed;
   const showCountryRequired = !hasValidCountry;

   const handleCountryChange = async (selectedCountry: any) => {
      if (!selectedCountry || !user) return;

      try {
         setIsUpdating(true);
         const response = await putUser({ country: selectedCountry.value });

         if (response.error) {
            const errorMessage = typeof response.error === 'string' ? response.error : response.error?.message || 'Failed to update country';
            toast.error(errorMessage);
            return;
         }

         if (response.data) {
            setUser(response.data);
            toast.success('Country updated successfully');
         }
      } catch (error) {
         toast.error('Failed to update country');
         console.error(error);
      } finally {
         setIsUpdating(false);
      }
   };

   return (
      <div className="sweepstakes-page">
         <div className="sweepstakes-header">
            <div className="sweepstakes-country-selector">
               <label htmlFor="country">Your Country</label>
               <div className="country-selector-wrapper">
                  <CountrySelect
                     options={countries}
                     value={countries.find((c) => c.value === user?.country)}
                     onChange={handleCountryChange}
                     placeholder={isUpdating ? 'Updating...' : 'Select your country'}
                  />
                  {isUpdating && (
                     <div className="country-selector-loader">
                        <div className="spinner"></div>
                     </div>
                  )}
               </div>
            </div>
         </div>

         {showCountryRequired && (
            <div className="sweepstakes-required">
               <div className="sweepstakes-required-icon">🌍</div>
               <div className="sweepstakes-required-content">
                  <strong>Country Selection Required</strong>
                  <p>Please select your country above to access sweepstakes.</p>
               </div>
            </div>
         )}

         {showWarning && (
            <div className="sweepstakes-warning">
               <div className="sweepstakes-warning-icon">⚠️</div>
               <div className="sweepstakes-warning-content">
                  <strong>Sweepstakes Not Available</strong>
                  <p>
                     Sweepstakes are not available in your country.
                     <Link
                        to="/sweepstakes-tos"
                        className="sweepstakes-tos-link"
                        target="_blank"
                        rel="noreferrer">
                        {' '}
                        Read more on Terms and Conditions
                     </Link>
                  </p>
               </div>
            </div>
         )}

         {hasValidCountry && (
            <StoreProducts
               raffles={raffles}
               setRaffles={setRaffles}
               origin="store"
            />
         )}
      </div>
   );
}
